<script setup>
import { inject, ref } from "vue";
import BaseRadioButtonGroup from "./formComponents/BaseRadioButtonGroup.vue";
import ReorderModifications from "./modifications/ReorderModifications.vue";
import NoModifications from "./nomodifications/NoModifications.vue";


const form = inject('form');


const reOrderMods = [
    {
        "id": 0, "title": "Yes",
    },
    {
        "id": 1, "title": "No",
    },
];

</script>

<template>


    <div class="border-t-2 mt-8" v-show="form.step == 'start'">

        <BaseRadioButtonGroup label="Reorder with modifications ?" :group="`reOrderModifications`"
            v-model="form.modificationsToDesign" :options="reOrderMods" requires='True'/>

        <ReorderModifications v-if="form.modificationsToDesign == 'Yes'" />

        <NoModifications v-else />


    </div>


</template>


